// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"48":"6182ffba0abd47cf","261":"63ecb0f7f8f52073","388":"94ac5113b2004fa6","641":"0b7ffe881b25f6a5","649":"e8da9e08a57f987a","736":"49182a3426b79bac","778":"245f16ff9a2d820b","944":"442f4e0cefd1c62c","957":"bcefdc0351ab45dc"}[chunkId] + ".js";
};